export const useCssVarsAccess = () => {

    const cssVars = {
        '--pmkinovar-access_color_typo': 'rgb(29, 29, 29)',
        '--pmkinovar-access_color_typo-inverse': '#fff',
        '--pmkinovar-access_color_background': '#eee',
        '--pmkinovar-access_accent_color_dark': '#005a9c',
        '--pmkinovar-access_accewnt_color_dark_trans': 'rgb(0 90 156 / 75%)',
        '--pmkinovar-access_accent_color_medium': '#ccc',
        '--pmkinovar-access_accent_color_light': '#ddd'
    }

    return cssVars

}